/*
	Paysites JS

	Author: Radek Senfeld <rush@logic.cz>
	Author: Martin Allien (https://allien.work), 2017
*/

$(document).ready(function () {
	// Adult Content
	$.adult.init();

	// Thumbnail rotator
	$.rotator.attach();

	// Video thumbnail
	$.videoThumbnail.init();

	// $.members.init();

	// Revive
	$('ins[data-revive-zoneids]').each(function (i, el) {
		var breakpoints = [599];
		var zoneids = $(el).data('revive-zoneids');

		if (Array.isArray(zoneids) && zoneids.length > 1) {
			for (var i = 0; i < breakpoints.length; i++) {
				if ($(window).width() <= breakpoints[i]) {
					break;
				}
			}

			$(el).attr('data-revive-zoneid', zoneids[i]);
		}
	});

	// Menu toggle (mobile)
	/*
	$('button.hamburger-menu').click(function () {
		$(this).toggleClass('is-open');
		$('.mobile-menu').toggleClass('open');
		$('ul.dropdown').slideToggle('fast');
		$.scrollLock();
	});*/

	// Menu - submenus toggle (desktop)
	/*$('.has-dropdown').click(function () {
		$(this).find('i.ico').toggleClass('active');
		$('ul.dropdown').slideToggle('fast');
	});*/

	// Language toggle (mobile)
	/*$('.language-selector').find('.current').click(function () {
		$(this).toggleClass('active');
		$('.language-selector').find('.available-languages').toggleClass('open');
	});*/

	// Search toggle (desktop)
	$('.search')
		.find('.search__button')
		.click(function () {
			if ($(this).next('.search-input').hasClass('active')) {
				$(this).next('.search-input').removeClass('active').css('visibility', 'hidden');
				setTimeout(function () {
					$('.ico-search').addClass('ico-search--close').removeClass('ico-search--open');
					$('.navbar__text').removeClass('disable').addClass('active');
					$('.search__menu').removeClass('active');
				}, 100);
			} else {
				$('.navbar__text').removeClass('active').addClass('disable');
				$(this).next('.search-input').addClass('active').focus().css('visibility', 'visible');
				$('.search__menu').addClass('active');
				setTimeout(function () {
					$('.ico-search').addClass('ico-search--open').removeClass('ico-search--close');
				}, 100);
			}
		});

	//
	$('form.search button.search-submit').on('click', function () {
		if ($(this).closest('.mobile-menu').hasClass('open')) {
			if ($(this).parent().find('input').val().trim().length === 0) {
				return false;
			}
		}
	});

	// Hide search input
	$('.desktop-menu .search-input').css('visibility', 'hidden');

	// Show full description
	const detailDescription = document.querySelector('.detail-description');

	if (detailDescription) {
		detailDescription.addEventListener('click', () => {
			const cover = detailDescription.querySelector('.detail-description__cover');

			detailDescription.style.cursor = 'default';
			detailDescription.style.setProperty('--clamp-rows', 'none');

			if (cover) {
				cover.style.display = 'none';
			}
		});
	}

	// Show full episode description (mobile)
	$('#show-more').click(function () {
		$(this).closest('.description').addClass('full');
	});

	// Join: show/hide password
	$('.show-pw').click(function () {
		var input = $('input#password');

		$(this).toggleClass('active');
		if ($(input).attr('type') === 'password') {
			$(input).attr('type', 'text');
		} else {
			$(input).attr('type', 'password');
		}
	});

	/* ------------------------------------------------- *\
		Magnific popup
		http://dimsemenov.com/plugins/magnific-popup/documentation.html
	\* ------------------------------------------------- */

	$('.lightbox-gallery').each(function () {
		$(this).magnificPopup({
			delegate: 'a.open',
			type: 'image',
			removalDelay: 300,
			mainClass: 'mfp-fade',
			autoFocusLast: false,
			fixedContentPos: false,
			fixedBgPos: false,
			tLoading: '',
			gallery: {
				enabled: true,
				arrowMarkup:
					'<button title="%title%" class="mfp-arrow mfp-arrow-%dir% test">\n' +
					'<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="none" viewBox="0 0 50 50">\n' +
					'  <path stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="m28.5 35-10-10 10-10"/>\n' +
					'</svg>\n' +
					'</button>'
			},
			image: {
				cursor: null,
				markup:
					'<div class="mfp-figure">' +
					'<div class="mfp-close"></div>' +
					'<div class="mfp-img"></div>' +
					'<div class="mfp-bottom-bar">' +
					'<div class="mfp-counter  p p3 text--c-white"></div>' +
					'</div>' +
					'</div>'
			},
			closeMarkup:
				'<button title="%title%" class="mfp-close">\n' +
				'<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">\n' +
				'  <path stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m4 4 16 16m0-16L4 20"/>\n' +
				'</svg>\n' +
				'</button>',
			// Prevent scrolling on mobile device (https://github.com/dimsemenov/Magnific-Popup/issues/782):
			callbacks: {
				buildControls: function () {
					this.contentContainer.append(this.arrowLeft.add(this.arrowRight));
				},
				open: function () {
					var mfp = this;
					var hammer = new Hammer(mfp.contentContainer[0]);

					if (hammer) {
						hammer.on('swipeleft', function () {
							mfp.next();
						});

						hammer.on('swiperight', function () {
							mfp.prev();
						});
					}
				}
			}
		});
	});

	/* --------------------------------------------- *\
		Video.js
	\* --------------------------------------------- */

	$('#video-container').on('contextmenu', function (event) {
		event.preventDefault();
	});

	// AR comparison for desktop
	function playerARCheck() {
		let windowWidth = $(window).width() - 128;
		let windowHeight = $(window).height() - 236;
		let ar = windowWidth / windowHeight;
		$('#video-container')
			.removeClass('hold-height hold-width')
			.addClass(ar > 16 / 9 ? 'hold-height' : 'hold-width');
	}

	if ($('body').data('page') === 'detail') {
		$(window).on('resize', function () {
			if ($(window).width() > 1039) {
				playerARCheck();
			}
		});
		playerARCheck();
	}

	// ------- PLUG-INS ------- //

	$('.video-js').each(function (videoIndex) {
		var videoId = $(this).attr('id');
		var player = videojs(videoId);

		player.on('ended', function () {
			if ($(videoId).data('play') !== 'True') {
				$.ajax({
					url: window.settings.urls.eventStore,
					type: 'GET',
					data: {
						event: 'video_ended',
						gallery_id: $(videoId).data('key')
					},
					success: function (response) {
						// console.log(response);
					},
					error: function (error) {
						console.error(error);
					}
				});
			}
		});

		videojs(videoId).ready(function () {
			// Hotkeys (https://www.npmjs.com/package/videojs-hotkeys)
			this.hotkeys({
				volumeStep: 0.1,
				seekStep: 5,
				enableModifiersForNumbers: false,
				enableVolumeScroll: false
			});
		});

		// Resolution Switcher (https://www.npmjs.com/package/videojs-resolution-switcher)
		videojs(videoId).videoJsResolutionSwitcher({
			default: $.browser.mobile ? 540 : 720,
			dynamicLabel: true
		});

		// "Join" splash after video playback is finished
		videojs(videoId).on('ended', function () {
			let video_ended = $('.video-player__ended');

			if (video_ended.length > 0) {
				video_ended.addClass('is-visible');
				$('.vjs-control-bar').css('display', 'none');
			}

			if (videojs($(videoId).get(0)).isFullscreen()) {
				videojs($(videoId).get(0)).exitFullscreen();
			}

			videojs(videoId, {
				autoplay: false,
				preload: 'auto'
			});

			let replay = $('.replay');
			if (replay) {
				$('.replay').click(function () {
					videojs($(videoId).get(0)).currentTime(0);
					videojs($(videoId).get(0)).play();
					video_ended.removeClass('is-visible');
					videojs($(videoId).get(0)).hotkeys({
						volumeStep: 0.1,
						seekStep: 5,
						enableModifiersForNumbers: false,
						enableVolumeScroll: false
					});
					setTimeout(function () {
						$('.vjs-control-bar').css('display', '');
					}, 100);
				});
			}
		});

		let video_js_unmute = $('.video-js__unmute');

		$('#video').on('click', function () {
			remove_btn_unmute();
		});

		video_js_unmute.on('click', function () {
			remove_btn_unmute();
		});

		function remove_btn_unmute() {
			if (video_js_unmute.length > 0) {
				videojs(videoId).muted(false);
				video_js_unmute.remove();
			}
		}
	});

	// ------- MISC ------- //
	// I am using css for all of this, to be removed
	/*
		// Calculate height of video
		function setVideoHeight() {
			var video = $('.video-js'),
				videoW = video.width(),
				videoH = videoW / 16 * 9;

			video.css({
				'height': videoH + 'px'
			});
		}

		setVideoHeight();

		$(window).resize(function() {
			setVideoHeight();
		});
*/

	// Switch video preview grid between mobile and tablet
	function responsiv(x) {
		if (x.matches) {
			// If media query matches
			$('.episode-tour')
				.find('.small-block-grid-2')
				.addClass('small-block-grid-1')
				.removeClass('small-block-grid-2');
		} else {
			$('.episode-tour')
				.find('.small-block-grid-1')
				.addClass('small-block-grid-2')
				.removeClass('small-block-grid-1');
		}
	}

	var x = window.matchMedia('(max-width: 546px)');
	responsiv(x); // Call listener function at run time
	x.addListener(responsiv); // Attach listener function on state changes

	let url = new URL(window.location.href);
	let param_url = url.searchParams.get('url');
	if (param_url) {
		localStorage.setItem('profile', param_url);
	}

	// Hero slider
	var $slider = $('.slider');
	var $slideVideo = $('.slide-video', $slider);

	function pauseAllVideos() {
		$slideVideo.each(function () {
			this.pause();
		});
	}

	function toggleVideoPlayback(play, $video) {
		$video = $video ?? $slider.find('.slick-current .slide-video')[0];

		if ($video) {
			if (play && $video.paused) {
				$video.play().then(() => {
					$video.muted = true;
				});
			} else if (!play && !$video.paused) {
				$video.pause();
			}
		}
	}

	//  Animate the Details Element Using WAAPI (https://css-tricks.com/how-to-animate-the-details-element-using-waapi/)
	class Accordion {
		constructor(el) {
			// Store the <details> element
			this.el = el;
			// Store the <summary> element
			this.summary = el.querySelector('summary');
			// Store the <div class="content"> element
			this.content = el.querySelector('summary + div');

			// Store the animation object (so we can cancel it if needed)
			this.animation = null;
			// Store if the element is closing
			this.isClosing = false;
			// Store if the element is expanding
			this.isExpanding = false;
			// Detect user clicks on the summary element
			this.summary.addEventListener('click', e => this.onClick(e));
		}

		onClick(e) {
			// Stop default behaviour from the browser
			e.preventDefault();

			// Add an overflow on the <details> to avoid content overflowing
			this.el.style.overflow = 'hidden';
			// Check if the element is being closed or is already closed
			if (this.isClosing || !this.el.open) {
				this.open();
				// Check if the element is being openned or is already open
			} else if (this.isExpanding || this.el.open) {
				this.shrink();
			}
		}

		shrink() {
			// Set the element as "being closed"
			this.isClosing = true;

			// Store the current height of the element
			const startHeight = `${this.el.offsetHeight}px`;
			// Calculate the height of the summary
			const endHeight = `${this.summary.offsetHeight}px`;

			// If there is already an animation running
			if (this.animation) {
				// Cancel the current animation
				this.animation.cancel();
			}

			// Start a WAAPI animation
			this.animation = this.el.animate(
				{
					// Set the keyframes from the startHeight to endHeight
					height: [startHeight, endHeight]
				},
				{
					duration: 400,
					easing: 'ease-out'
				}
			);

			// When the animation is complete, call onAnimationFinish()
			this.animation.onfinish = () => this.onAnimationFinish(false);
			// If the animation is cancelled, isClosing variable is set to false
			this.animation.oncancel = () => (this.isClosing = false);
		}

		open() {
			// Apply a fixed height on the element
			this.el.style.height = `${this.el.offsetHeight}px`;
			// Force the [open] attribute on the details element
			this.el.open = true;
			// Wait for the next frame to call the expand function
			window.requestAnimationFrame(() => this.expand());
		}

		expand() {
			// Set the element as "being expanding"
			this.isExpanding = true;
			// Get the current fixed height of the element
			const startHeight = `${this.el.offsetHeight}px`;
			// Calculate the open height of the element (summary height + content height)
			const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

			// If there is already an animation running
			if (this.animation) {
				// Cancel the current animation
				this.animation.cancel();
			}

			// Start a WAAPI animation
			this.animation = this.el.animate(
				{
					// Set the keyframes from the startHeight to endHeight
					height: [startHeight, endHeight]
				},
				{
					duration: 400,
					easing: 'ease-out'
				}
			);
			// When the animation is complete, call onAnimationFinish()
			this.animation.onfinish = () => this.onAnimationFinish(true);
			// If the animation is cancelled, isExpanding variable is set to false
			this.animation.oncancel = () => (this.isExpanding = false);
		}

		onAnimationFinish(open) {
			// Set the open attribute based on the parameter
			this.el.open = open;
			// Clear the stored animation
			this.animation = null;
			// Reset isClosing & isExpanding
			this.isClosing = false;
			this.isExpanding = false;
			// Remove the overflow hidden and the fixed height
			this.el.style.height = this.el.style.overflow = '';
		}
	}

	document.querySelectorAll('details').forEach(el => {
		new Accordion(el);
	});
}); // document.ready
